import angular from 'angular';
import officeAddress from './officeAddress';
import './style.scss';

export default angular
  .module('components.officeAddress', [])
  .component('officeAddress', officeAddress).name;
